var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaggingPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13047 0.563865C6.21052 0.394604 6.33433 0.252096 6.48791 0.152452C6.64149 0.0528071 6.81871 0 6.99953 0C7.18036 0 7.35757 0.0528071 7.51115 0.152452C7.66473 0.252096 7.78854 0.394604 7.8686 0.563865L9.50657 4.02869L13.1691 4.58405C13.3482 4.61101 13.5164 4.68974 13.6549 4.81134C13.7933 4.93294 13.8963 5.09255 13.9523 5.27211C14.0084 5.45168 14.0151 5.64402 13.9719 5.8274C13.9286 6.01077 13.8371 6.17784 13.7076 6.30972L11.0562 9.00783L11.6819 12.8155C11.7123 13.0016 11.6923 13.1928 11.6241 13.3675C11.5559 13.5423 11.4422 13.6937 11.2959 13.8045C11.1496 13.9154 10.9765 13.9813 10.7962 13.9949C10.6159 14.0085 10.4355 13.9691 10.2755 13.8813L6.99953 12.0848L3.72357 13.8835C3.56339 13.9716 3.38278 14.011 3.20223 13.9974C3.02168 13.9837 2.84839 13.9176 2.70199 13.8064C2.5556 13.6953 2.44196 13.5435 2.37394 13.3684C2.30592 13.1933 2.28624 13.0017 2.31713 12.8155L2.94174 9.00783L0.292544 6.31084C0.163075 6.17904 0.0715102 6.01206 0.028203 5.82877C-0.0151043 5.64548 -0.00842666 5.4532 0.0474808 5.27366C0.103388 5.09413 0.206295 4.9345 0.344567 4.81283C0.482839 4.69117 0.65096 4.61231 0.829922 4.58518L4.49141 4.02981L6.13047 0.563865Z",
    fill: "url(#paint0_linear_6248_11557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6248_11557",
    x1: 13.9984,
    y1: 14.313,
    x2: -0.986337,
    y2: 0.777679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD0F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggingPremium);
export default __webpack_public_path__ + "static/media/tagging_premium.5bd58c537f3cce4d48465959572f8288.svg";
export { ForwardRef as ReactComponent };